<template>
  <FormBuilder
    class="space-y-4"
    :validation-schema="validationSchema"
    @submit="onSubmit"
    @input="error = null"
    v-slot="{ isSubmitting }"
  >
    <InputText id="name" name="name" v-model="orgName" :readonly="organizationId" :label="$t('organizationName')" required />
    <InputText  id="authenticationEndpoint" v-model="authUrl" name="authenticationEndpoint" :label="$t('authenticationEndpoint')"/>
    <div class="space-y-1">
      <label style="margin-top: 45px" for="configuration">Configuration</label>
      <div>
        <JsonEditorVue
          id="configuration"
          name="configuration"
          class="jse-theme-dark h-[40vh]"
          v-model="configuration"
          :mode="Mode.text"
          :stringified="false"
          :mainMenuBar="false"
          :debounce="50"
        />
      </div>
    </div>
    <div class="text-end">
      <BaseButton type="submit" :disabled="isSubmitting">{{
        organizationId ? $t("startUpdate") : $t("startCreate")
      }}</BaseButton>
    </div>
    <BaseBoxColor v-if="error" class="w-full" variant="danger">{{
      error
    }}</BaseBoxColor>
  </FormBuilder>
</template>

<script setup>
import { ref, onMounted, readonly } from "vue";
import { useI18n } from "vue-i18n";
import useOrganizationStore from "@/stores/organization";
import useModalStore from "@/stores/modal";
import useToastStore from "@/stores/toast";
import validationSchema from "./validationSchemas.js";
import JsonEditorVue from 'json-editor-vue'
import 'vanilla-jsoneditor/themes/jse-theme-dark.css'
import { Mode } from 'vanilla-jsoneditor'

const { addOrganization, updateOrganization } = useOrganizationStore();
const { addToast } = useToastStore();
const { closeModal } = useModalStore();
const error = ref(null);
const { t } = useI18n();

const configuration = ref({});
const orgName = ref("");
const authUrl = ref("");

onMounted(() => {
  if(props.organizationConfiguration) {
    configuration.value = props.organizationConfiguration ? JSON.parse(props.organizationConfiguration) : configuration.value
  }
  if(props.organizationId) {
    orgName.value = props.organizationName ?? '';
    authUrl.value = props.organizationAuthenticationEndpoint ?? null;
  }
});

/**
 * handle form submit
 * @param {Object} values
 * @param {Function} resetForm
 */
async function onSubmit(values) {
  try {

    if(!values.authenticationEndpoint || values.authenticationEndpoint == "") {
      values.authenticationEndpoint = null;
    }

    if(configuration.value && configuration.value !== "") {
      values.configuration = configuration.value
    }
    // debugger
    if(props.organizationId) {
      await updateOrganization(props.organizationId, values);
    } else {
      await addOrganization(values);
    }
    addToast({
      content: props.organizationId ? t("itemUpdated") : t("itemCreated"),
      variant: "success",
    });
    closeModal();
  } catch (err) {
    error.value = err;
  }
}

const props = defineProps({
  organizationId: {
    type: Number,
    required: false
  },
  organizationName: {
    type: String,
    required: false
  },
  organizationAuthenticationEndpoint: {
    type: String,
    required: false,
  },
  organizationConfiguration: {
    type: String,
    required: false
  }
});
</script>
